import React from "react";
import * as ReactDOM from "react-dom/client";
import "./landing-shared.entry.jsx";
const SiteNav = globalThis.SiteNav ?? globalThis.window?.SiteNav;
const SiteFooter = globalThis.SiteFooter ?? globalThis.window?.SiteFooter;
const { useState, useEffect } = React;

const SIDEBAR = [
  {
    title: 'Start here',
    items: [
      { id: 'introduction', label: 'Overview', active: true, href: '#introduction' },
      { id: 'before-you-begin', label: 'Before you begin', href: '#before-you-begin' },
      { id: 'workspace', label: 'Create a workspace', href: '#workspace' },
      { id: 'device', label: 'Install and enroll a device', href: '#device' },
      { id: 'first-app', label: 'Protect your first app', href: '#first-app' },
      { id: 'share-access', label: 'Share access safely', href: '#share-access' },
    ],
  },
  {
    title: 'Services',
    items: [
      { id: 'service-dns', label: 'Secure DNS', beta: true, href: '#service-dns' },
      { id: 'service-network', label: 'Private Network', beta: true, href: '#service-network' },
      { id: 'service-ai', label: 'AI & Automation', beta: true, href: '#service-ai' },
      { id: 'service-egress', label: 'Gateway & Exit Nodes', beta: true, href: '#service-egress' },
    ],
  },
  {
    title: 'Developers',
    items: [
      { id: 'dev-mcp', label: 'Hosted MCP', href: '#dev-mcp' },
      { id: 'dev-api', label: 'Control-plane API', href: '#dev-api' },
      { id: 'dev-agent', label: 'Agent & local stdio', href: '#dev-agent' },
    ],
  },
  {
    title: 'Help',
    items: [
      { id: 'help', label: 'Troubleshooting', href: '#help' },
      { id: 'next-steps', label: 'Next steps', href: '#next-steps' },
    ],
  },
];

const TOC = [
  { id: 'before-you-begin', label: 'Before you begin' },
  { id: 'workspace', label: 'Create a workspace' },
  { id: 'device', label: 'Install and enroll a device' },
  { id: 'first-app', label: 'Protect your first app', sub: [
    { id: 'choose-local-app', label: 'Choose the local app' },
    { id: 'choose-link-name', label: 'Choose the link name' },
    { id: 'share-access', label: 'Share access' },
  ]},
  { id: 'advanced-services', label: 'Advanced services' },
  { id: 'service-dns', label: 'Secure DNS' },
  { id: 'service-network', label: 'Private Network' },
  { id: 'service-ai', label: 'AI & Automation' },
  { id: 'service-egress', label: 'Gateway & Exit Nodes' },
  { id: 'developer-surfaces', label: 'Developers' },
  { id: 'dev-mcp', label: 'Hosted MCP' },
  { id: 'dev-api', label: 'Control-plane API' },
  { id: 'dev-agent', label: 'Agent & local stdio' },
  { id: 'help', label: 'Troubleshooting' },
  { id: 'next-steps', label: 'Next steps' },
];

function DocsBar() {
  return (
    <div className="docs-bar">
      <div className="docs-bar-inner">
        <div className="docs-bar-l">
          <span className="pill">Docs</span>
          <h1>Product guide</h1>
        </div>
        <div className="docs-search">
          <span className="ico">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.4"/>
              <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.4"/>
            </svg>
          </span>
          <input placeholder="Search setup, sharing, DNS, API…" />
          <span className="kbd">⌘K</span>
        </div>
        <div className="docs-bar-r">
          <span className="vsel">Current</span>
          <a className="vlink" href="status">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
              <path d="M8 0C3.58 0 0 3.58 0 8a8 8 0 005.47 7.59c.4.07.55-.17.55-.38v-1.49c-2.23.48-2.7-.94-2.7-.94-.36-.92-.89-1.17-.89-1.17-.73-.5.06-.49.06-.49.81.06 1.23.83 1.23.83.72 1.23 1.88.87 2.34.67.07-.52.28-.87.5-1.07-1.78-.2-3.65-.89-3.65-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.13 0 0 .67-.21 2.2.82a7.66 7.66 0 014 0c1.53-1.03 2.2-.82 2.2-.82.44 1.11.16 1.93.08 2.13.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.74.54 1.49v2.21c0 .21.15.46.55.38A8 8 0 0016 8c0-4.42-3.58-8-8-8z"/>
            </svg>
            Status
          </a>
        </div>
      </div>
    </div>
  );
}

function Sidebar({ activeId }) {
  return (
    <aside className="docs-side">
      {SIDEBAR.map((g, i) => (
        <div key={i}>
          <h4>{g.title}</h4>
          <ul>
            {g.items.map(it => (
              <li key={it.id}>
                <a href={it.href || `#${it.id}`} className={it.id === activeId ? 'is-active' : ''}>
                  <span>{it.label}</span>
                  {it.new && <span className="pill-new">NEW</span>}
                  {it.beta && <span className="pill-beta">BETA</span>}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </aside>
  );
}

function CopyButton({ label = 'Copy' }) {
  const [done, setDone] = useState(false);
  return (
    <button className="copy" onClick={(e) => {
      const code = e.currentTarget.closest('.codeblock').querySelector('pre').textContent;
      navigator.clipboard.writeText(code);
      setDone(true);
      setTimeout(() => setDone(false), 1200);
    }}>{done ? 'Copied' : label}</button>
  );
}

function Code({ lang, children }) {
  return (
    <div className="codeblock">
      <div className="codeblock-head">
        <span className="lang">{lang}</span>
        <CopyButton />
      </div>
      <pre>{children}</pre>
    </div>
  );
}

function MultiCode({ tabs }) {
  const [t, setT] = useState(0);
  return (
    <>
      <div className="doc-tabs">
        {tabs.map((tab, i) => (
          <button key={i} className={i === t ? 'is-active' : ''} onClick={() => setT(i)}>{tab.label}</button>
        ))}
      </div>
      <div className="codeblock" style={{ marginTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTop: 'none' }}>
        <div className="codeblock-head">
          <span className="lang">{tabs[t].lang}</span>
          <CopyButton />
        </div>
        <pre>{tabs[t].body}</pre>
      </div>
    </>
  );
}

function Article() {
  const gettingStartedTabs = [
    { label: 'Dashboard', lang: 'text', body: (
      <>/login{'\n'}
      /signup{'\n'}
      /dashboard/apps{'\n'}
      /dashboard/devices{'\n'}
      /dashboard/access</>
    )},
    { label: 'Agent', lang: 'shell', body: (
      <><span className="cb-prompt">$ </span>namedn platform{'\n'}
      <span className="cb-prompt">$ </span>namedn status{'\n'}
      <span className="cb-prompt">$ </span>namedn mcp serve</>
    )},
    { label: 'Hosted MCP', lang: 'text', body: (
      <>https://mcp.named.network/mcp{'\n'}
      mcp:devices:read{'\n'}
      mcp:private_apps:read{'\n'}
      mcp:egress:write</>
    )},
  ];

  return (
    <main className="docs-main">
      <div className="crumbs">
        <a href="#docs">Docs</a>
        <span className="sep">/</span>
        <a href="#introduction">Overview</a>
        <span className="sep">/</span>
        <span style={{ color: 'var(--text-light-primary)' }}>Use the product</span>
      </div>

      <h1 id="introduction">Use named.network without <em>opening public ports.</em></h1>
      <p className="lede">
        named.network helps you protect local apps, internal tools, and trusted devices behind
        identity-aware access. Most people should start with one device, one private app, and one
        person who needs access.
      </p>

      <div className="callout">
        <strong>Best place to start:</strong> create a workspace, enroll one device, protect one app,
        then share access by email. The advanced services are there when you need them, but the first
        success case should stay simple.
      </div>

      <h2 id="before-you-begin">Before you begin</h2>
      <p>
        You do not need to open inbound ports on your router or publish an admin panel to the public internet.
        The product is built around outbound connectivity from the device running the app and identity-aware access
        for the person opening it.
      </p>
      <p>
        The main current product path is Private Apps. Around that, named.network also includes Secure DNS,
        Private Network, AI &amp; Automation, Controlled Gateway, and Exit Nodes as advanced services with their own
        plan, support, and operating boundaries.
      </p>

      <h2 id="workspace">Create a workspace</h2>
      <p>
        Start from the sign-up or sign-in flow, then create a workspace name you will recognize later.
        That workspace becomes the home for your devices, protected apps, access rules, billing, and advanced services.
      </p>
      <p>
        Once you are in the dashboard, the three most important places are:
      </p>

      <MultiCode tabs={gettingStartedTabs} />

      <h2 id="device">Install and enroll a device</h2>
      <p>
        Go to <strong>Devices</strong>, generate the setup command, and run it on the computer or server that hosts
        the app you want to protect. The product already supports real Agent enrollment and real device state in the dashboard.
      </p>
      <p>
        After install, the device should appear as one of the live states the product uses today:
        <code> ready</code>, <code>connecting</code>, or <code>off</code>. If it is ready, you can move straight into app protection.
      </p>

      <h2 id="first-app">Protect your first app</h2>
      <p>
        This is the core flow. Open <strong>Protected Apps</strong> and either review an app the Agent already detected
        or enter the local address manually.
      </p>

      <ol className="step-list">
        <li>
          <h3 id="choose-local-app">Choose the local app</h3>
          <p>
            If the Agent already found something useful, review it and continue. If not, enter the local app address
            manually and choose the device that hosts it.
          </p>
        </li>
        <li>
          <h3 id="choose-link-name">Choose the named link</h3>
          <p>
            Give the app a clear name and a safe hostname. The dashboard now supports creating, editing,
            and deleting protected apps directly from the real product surface.
          </p>
        </li>
        <li>
          <h3 id="share-access">Share access</h3>
          <p>
            Use email-based sharing and app access rules instead of passwords. The Access surface now supports
            invitations, request review, direct rules, expiry edits, revocation, and member-level troubleshooting.
          </p>
        </li>
      </ol>

      <h2 id="advanced-services">Advanced services</h2>
      <p>
        Once the private-app path is working, the rest of the product becomes useful in context rather than in isolation.
        These sections are docs, not landing pages: they explain what each feature is for, where to configure it,
        and what to check before you rely on it.
      </p>

      <h3 id="service-dns">Secure DNS</h3>
      <p>
        Use Secure DNS when you want profile-based DNS filtering, allow or block rules, device assignment,
        and live DNS summaries. It is a real beta surface, not just a future idea.
      </p>
      <ul>
        <li><strong>Where to configure it:</strong> open <code>/dashboard/dns</code>.</li>
        <li><strong>Start with:</strong> one profile, one or two block rules, then assign it to one ready device.</li>
        <li><strong>Good for:</strong> blocking trackers, malware domains, noisy categories, or known-bad internal destinations.</li>
        <li><strong>Not for:</strong> replacing app-level authorization. DNS rules are a network layer control, not user identity.</li>
      </ul>
      <Code lang="text">
        dashboard · /dashboard/dns{'\n'}
        profile   · name, default action, rules{'\n'}
        assign    · profile to device{'\n'}
        verify    · DNS summary and blocked query history
      </Code>

      <h3 id="service-network">Private Network</h3>
      <p>
        Use Private Network when you need device-to-device connectivity, route control, server access,
        and operator visibility over peer health and network state.
      </p>
      <ul>
        <li><strong>Where to configure it:</strong> open <code>/dashboard/network</code>.</li>
        <li><strong>Start with:</strong> two enrolled devices, then approve only the route you actually need.</li>
        <li><strong>Good for:</strong> trusted device access, private service reachability, and controlled internal routes.</li>
        <li><strong>Watch for:</strong> stale devices, broad routes, or a route that has not been explicitly approved.</li>
      </ul>
      <Code lang="text">
        dashboard · /dashboard/network{'\n'}
        device    · ready enrolled agent{'\n'}
        route     · requested, approved, revoked{'\n'}
        verify    · peer health and route status
      </Code>

      <h3 id="service-ai">AI &amp; Automation</h3>
      <p>
        Use AI &amp; Automation when you want hosted MCP for remote assistants, scoped business tokens,
        and local <code>namedn mcp serve</code> for same-machine workflows.
      </p>
      <ul>
        <li><strong>Where to configure it:</strong> open <code>/dashboard/ai</code>.</li>
        <li><strong>Start with:</strong> create one scoped automation token for one assistant.</li>
        <li><strong>Remote assistant:</strong> use Hosted MCP over HTTPS with <code>NAMED_NETWORK_MCP_TOKEN</code>.</li>
        <li><strong>Local assistant:</strong> use the local MCP bridge only when the assistant runs on the same machine as <code>namedn</code>.</li>
      </ul>
      <MultiCode tabs={[
        { label: 'Remote', lang: 'text', body: (
          <>endpoint · https://mcp.named.network/mcp{'\n'}
          token    · NAMED_NETWORK_MCP_TOKEN=&lt;shown once&gt;{'\n'}
          use for  · Codex cloud, CI, remote runners, hosted assistants</>
        )},
        { label: 'Local', lang: 'shell', body: (
          <><span className="cb-prompt">$ </span>namedn mcp serve --config /etc/namedn/agent.yaml{'\n'}
          use for · Claude Desktop or local tools on the same computer</>
        )},
      ]} />

      <h3 id="service-egress">Gateway &amp; Exit Nodes</h3>
      <p>
        Use Controlled Gateway for bounded public web tasks with visible history and revoke controls.
        Use Exit Nodes for trusted-device egress when you need selected traffic to leave through a device
        your workspace already trusts.
      </p>
      <ul>
        <li><strong>Controlled Gateway:</strong> open <code>/dashboard/gateway</code> for short-lived, capped outbound tasks.</li>
        <li><strong>Exit Nodes:</strong> open <code>/dashboard/exit-nodes</code> for trusted-device egress paths.</li>
        <li><strong>Use Gateway when:</strong> a script or agent needs a narrow allowlist, expiry, and audit history.</li>
        <li><strong>Use Exit Nodes when:</strong> traffic should leave through a device your workspace owns and operates.</li>
      </ul>
      <p>
        Exit Nodes are a Business workspace feature for owners and admins. The current supported exit-host set is
        Linux systemd on Ubuntu 24.04 LTS, Debian 12, and AlmaLinux 9. Ubuntu 26.04 is not part of the support
        promise until it passes the same live matrix.
      </p>
      <ul>
        <li><strong>Policies:</strong> <code>routes_only</code>, <code>split_tunnel</code>, <code>all_traffic</code>, and <code>disabled</code>.</li>
        <li><strong>All traffic:</strong> sends the client IPv4 default route through the selected exit while preserving named.network control-plane reachability.</li>
        <li><strong>DNS and IPv6:</strong> supported hosts passed DNS and IPv6 leak checks; unsupported direct IPv6 egress fails closed rather than silently bypassing the tunnel.</li>
        <li><strong>Disable and revoke:</strong> disable a session, remove exit eligibility, disable a device, or revoke unused setup tokens when access should stop. Disabled sessions stay visible for audit history.</li>
        <li><strong>Known limits:</strong> no anonymous browsing claim, no shared public exit pool, no streaming-unblock promise, no desktop kill-switch UX, and SMTP-class forwarding is blocked by default.</li>
      </ul>
      <Code lang="text">
        controlled gateway · /dashboard/gateway{'\n'}
        exit nodes         · /dashboard/exit-nodes{'\n'}
        supported hosts    · Ubuntu 24.04 LTS, Debian 12, AlmaLinux 9{'\n'}
        policies           · routes_only, split_tunnel, all_traffic, disabled{'\n'}
        stop egress        · disable session or remove exit eligibility{'\n'}
        not promised       · anonymity, streaming bypass, Ubuntu 26.04
      </Code>

      <h2 id="developer-surfaces">For developers</h2>
      <p>
        The developer story is real, but it should be understood in the right order: hosted MCP first,
        control-plane API second, local Agent bridge when the tool and the Agent are on the same machine.
      </p>

      <h3 id="dev-mcp">Hosted MCP</h3>
      <p>
        Hosted MCP is the primary remote-assistant integration surface. It is scoped, approval-aware,
        and aligned with the Business automation model.
      </p>
      <p>
        Use Hosted MCP when the assistant cannot launch commands on the same machine as your Agent. This includes
        cloud-hosted Codex runs, CI, remote worker machines, and any external agent client that can connect over HTTPS.
      </p>
      <ul>
        <li><strong>Requirement:</strong> Business plan and an active scoped automation token.</li>
        <li><strong>Token model:</strong> create a separate token per assistant, runner, or machine.</li>
        <li><strong>Scope model:</strong> grant only the MCP scope family the assistant needs.</li>
        <li><strong>Revocation:</strong> revoke the token when the assistant or machine is no longer trusted.</li>
      </ul>
      <MultiCode tabs={[
        { label: 'Codex', lang: 'toml', body: (
          <># ~/.codex/config.toml{'\n'}
          [mcp_servers.named-network]{'\n'}
          url = "https://mcp.named.network/mcp"{'\n'}
          headers = {'{'} Authorization = "Bearer ${'{'}NAMED_NETWORK_MCP_TOKEN{'}'}" {'}'}</>
        )},
        { label: 'Token env', lang: 'shell', body: (
          <><span className="cb-prompt">$ </span>export NAMED_NETWORK_MCP_TOKEN="token-shown-once"</>
        )},
      ]} />

      <h3 id="dev-api">Control-plane API</h3>
      <p>
        The API is real and versioned under <code>/v1</code>. It already backs the dashboard flows for devices,
        private apps, DNS, private network, gateway sessions, and token management.
      </p>
      <p>
        Customer-facing integrations should prefer Hosted MCP unless you are building a first-party control-plane
        integration. The API is session or token authenticated, workspace scoped, and should be treated as an operator
        surface rather than a public anonymous API.
      </p>
      <table className="doc-table">
        <thead>
          <tr><th>Area</th><th>Example path</th><th>Use</th></tr>
        </thead>
        <tbody>
          <tr><td>Devices</td><td><code>/v1/workspaces/{'{workspaceId}'}/devices</code></td><td>Read enrolled device state.</td></tr>
          <tr><td>Protected apps</td><td><code>/v1/workspaces/{'{workspaceId}'}/private-apps</code></td><td>Create and manage private app entries.</td></tr>
          <tr><td>Secure DNS</td><td><code>/v1/workspaces/{'{workspaceId}'}/dns/profiles</code></td><td>List or create DNS profiles.</td></tr>
          <tr><td>Gateway</td><td><code>/v1/workspaces/{'{workspaceId}'}/gateway-sessions</code></td><td>Create bounded outbound sessions.</td></tr>
          <tr><td>Automation tokens</td><td><code>/v1/workspaces/{'{workspaceId}'}/api-tokens</code></td><td>Manage scoped Business tokens.</td></tr>
        </tbody>
      </table>

      <h3 id="dev-agent">Agent &amp; local stdio</h3>
      <p>
        The local Agent bridge is exposed through <code>namedn mcp serve</code>. That path is for same-machine tools
        like local editors or agents, not for the public internet.
      </p>
      <ul>
        <li><strong>Agent runtime:</strong> install and enroll the Agent from the Devices page.</li>
        <li><strong>Run foreground:</strong> use <code>namedn agent run --config ...</code> for debugging.</li>
        <li><strong>Run as service:</strong> use the OS service created by the installer.</li>
        <li><strong>Local MCP:</strong> use <code>namedn mcp serve</code> only for local assistant clients.</li>
      </ul>
      <MultiCode tabs={[
        { label: 'macOS', lang: 'shell', body: (
          <><span className="cb-prompt">$ </span>launchctl list | grep namedn{'\n'}
          <span className="cb-prompt">$ </span>~/.namedn/bin/namedn status --config "$HOME/Library/Application Support/namedn/agent.yaml"</>
        )},
        { label: 'Linux', lang: 'shell', body: (
          <><span className="cb-prompt">$ </span>sudo systemctl status namedn-agent{'\n'}
          <span className="cb-prompt">$ </span>namedn status --config /etc/namedn/agent.yaml</>
        )},
        { label: 'Windows', lang: 'powershell', body: (
          <>PS&gt; Get-Service namedn-agent{'\n'}
          PS&gt; &amp; "$env:ProgramFiles\namedn\namedn.exe" status --config "$env:ProgramData\namedn\agent.yaml"</>
        )},
      ]} />

      <Code lang="text">
        hosted MCP   · https://mcp.named.network/mcp{'\n'}
        local bridge · namedn mcp serve{'\n'}
        dashboard    · apps, devices, access, DNS, network, gateway{'\n'}
        API          · /v1/workspaces/{'{workspaceId}'}/…
      </Code>

      <h2 id="help">Troubleshooting</h2>
      <p>
        If something does not work, start with the dashboard state first:
      </p>
      <ul>
        <li><strong>Device status</strong>: ready, connecting, or off</li>
        <li><strong>App status</strong>: ready, awaiting first check, agent offline, or off</li>
        <li><strong>Access</strong>: invitation, request, direct rule, expiry, or revocation state</li>
      </ul>
      <p>
        The current product also includes stronger support surfaces than before: app-level and workspace-level access investigation,
        blocked-open history, support notes for advanced networking pages, and a public status page.
      </p>

      <div className="callout">
        If a private app still will not open, check three things in order: the hosting device is ready, the app itself is ready,
        and the person opening it actually has current access.
      </div>

      <h2 id="next-steps">Next steps</h2>
      <p>Pick the page that matches what you want to do next.</p>

      <table className="doc-table">
        <thead>
          <tr><th style={{ width: '32%' }}>If you want to…</th><th>Open</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Protect a local app</strong></td><td><a href="#first-app">Protected Apps docs</a></td></tr>
          <tr><td><strong>Set up DNS filtering</strong></td><td><a href="#service-dns">Secure DNS docs</a></td></tr>
          <tr><td><strong>Connect devices privately</strong></td><td><a href="#service-network">Private Network docs</a></td></tr>
          <tr><td><strong>Connect an assistant or automation</strong></td><td><a href="#service-ai">AI &amp; Automation docs</a></td></tr>
          <tr><td><strong>Understand the API or MCP surface</strong></td><td><a href="#developer-surfaces">Developer docs</a></td></tr>
          <tr><td><strong>Use bounded egress</strong></td><td><a href="#service-egress">Controlled Gateway docs</a></td></tr>
          <tr><td><strong>Use trusted-device egress</strong></td><td><a href="#service-egress">Exit Nodes docs</a></td></tr>
          <tr><td><strong>Get help</strong></td><td><a href="/contact">Contact</a> or <a href="status">Status</a></td></tr>
        </tbody>
      </table>

      <div className="doc-foot">
        <a className="prev" href="#help">
          <div className="lbl">Previous</div>
          <div className="ttl">Troubleshooting</div>
        </a>
        <a className="next" href="#first-app">
          <div className="lbl">Next</div>
          <div className="ttl">Protected Apps</div>
        </a>
      </div>

      <div className="doc-meta">
        <span>Last updated · June 6, 2026</span>
        <span><a href="/contact">Need something missing? Contact us</a></span>
      </div>
    </main>
  );
}

function TocRail() {
  const [current, setCurrent] = useState('before-you-begin');
  useEffect(() => {
    function onScroll() {
      const ids = TOC.flatMap(t => [t.id, ...(t.sub || []).map(s => s.id)]);
      let active = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top < 120) active = id;
      }
      setCurrent(active);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <aside className="docs-toc">
      <h5>On this page</h5>
      <ul>
        {TOC.map(t => (
          <React.Fragment key={t.id}>
            <li><a href={`#${t.id}`} className={current === t.id ? 'is-current' : ''}>{t.label}</a></li>
            {t.sub && (
              <li>
                <ul className="nested">
                  {t.sub.map(s => (
                    <li key={s.id}>
                      <a href={`#${s.id}`} className={current === s.id ? 'is-current' : ''}>{s.label}</a>
                    </li>
                  ))}
                </ul>
              </li>
            )}
          </React.Fragment>
        ))}
      </ul>

      <div className="toc-feedback">
        <div>Was this page useful?</div>
        <div className="row">
          <button>Yes</button>
          <button>No</button>
        </div>
      </div>

      <div style={{ marginTop: 28, fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-light-muted)', lineHeight: 1.6 }}>
        <div style={{ marginBottom: 6 }}><strong style={{ color: 'var(--text-light-secondary)' }}>Need help?</strong></div>
        <div>· <a href="/contact" style={{ color: 'var(--text-light-secondary)', borderBottom: '1px solid var(--border-light)', textDecoration: 'none' }}>Email support</a></div>
        <div>· <a href="status" style={{ color: 'var(--text-light-secondary)', borderBottom: '1px solid var(--border-light)', textDecoration: 'none' }}>Check status</a></div>
        <div>· <a href="/about" style={{ color: 'var(--text-light-secondary)', borderBottom: '1px solid var(--border-light)', textDecoration: 'none' }}>About the product</a></div>
      </div>
    </aside>
  );
}

function App() {
  return (
    <>
      <SiteNav />
      <div className="docs-shell">
        <DocsBar />
        <div className="docs-body">
          <Sidebar activeId="introduction" />
          <Article />
          <TocRail />
        </div>
      </div>
      <SiteFooter />
    </>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

